// extracted by mini-css-extract-plugin
module.exports = {"ToolsContainer":"ToolsSidebar_ToolsContainer__3OrPE"};